import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, DataTableColumn, GenericIndexScene, Input } from 'lib/releox-react';
import OrderColumn from '../../columns/OrderColumn';
import routes from '../../configs/routes';
import ClientsEffect from '../../store/client/ClientsEffect';
import OrdersAction from '../../store/order/OrdersAction';
import OrderQuery from '../../store/order/OrdersQuery';
import OrdersSelector from '../../store/order/OrdersSelector';
import UsersSelector from '../../store/user/UsersSelector';

/*
 * The API runs on MongoDB, where Loopback turns a `like` value into a regular
 * expression. SQL style `%` wildcards would be matched literally, so the term
 * is escaped and used as a plain "contains" pattern instead.
 */
const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/* Keep the generated clientId list a sane size for very short search terms */
const CLIENT_SEARCH_LIMIT = 200;

const columns: DataTableColumn[] = [
  OrderColumn.orderNumber,
  OrderColumn.clientName,
  OrderColumn.phone,
  OrderColumn.address,
  OrderColumn.isPackaged,
  OrderColumn.createdAt,
];

export default () => {
  const user = useSelector(UsersSelector.selectUser);
  const [searchWhere, setSearchWhere] = useState<any>(null);

  const baseQuery = OrderQuery.getBuyerModifyIndex(user);

  const query = searchWhere
    ? { ...baseQuery, where: { ...baseQuery.where, ...searchWhere } }
    : baseQuery;

  const onSubmit = async ({ q }: { q: string }) => {
    const term = (q || '').trim();
    if (!term) {
      setSearchWhere(null);
      return;
    }
    const namePattern = escapeRegExp(term);
    /* Phone numbers are stored without spaces and dashes */
    const phonePattern = escapeRegExp(term.replace(/[\s-]/g, ''));
    const clients = await ClientsEffect.find({
      where: {
        or: [
          { phone: { like: phonePattern, options: 'i' } },
          { firstName: { like: namePattern, options: 'i' } },
          { lastName: { like: namePattern, options: 'i' } },
        ],
      },
      limit: CLIENT_SEARCH_LIMIT,
    });
    /* An empty inq matches nothing, which is what an empty result should show */
    setSearchWhere({ clientId: { inq: clients.map((c) => c.id) } });
  };

  return (
    <>
      <Card>
        <Formik initialValues={{ q: '' }} onSubmit={onSubmit}>
          <Form>
            <Input name="q" label="Search (name or phone)" />
          </Form>
        </Formik>
      </Card>
      <GenericIndexScene
        key={JSON.stringify(query.where)}
        tNamespace="ModifyIndexScene"
        loadingSelector={OrdersSelector.selectIsListLoading}
        dataSelector={OrdersSelector.selectOrders}
        dataSizeSelector={OrdersSelector.selectOrdersCount}
        onChangeLoopback={OrdersAction.list}
        columns={columns}
        defaultSorted={{ order: 'DESC', dataField: 'createdAt' }}
        query={query}
        redirectUrl={routes.BUYER.MODIFY_ORDERS_EDIT}
      />
    </>
  );
};
